import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
import DokumenteSlider from '../components/DokumenteSlider';
import TitleTextButton from '../modules/TitleTextButton';
import ImageTitleTextButton from '../modules/ImageTitleTextButton';
import Header_2 from '../headers/Header_2';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';
import SEO from '../components/Seo';
import Button from '../components/Button';

export const FreieMietobjekte = () => {

    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [hoveredId, setHoveredId] = useState(null);
    const mouseMove = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        setPosition({
            x: e.clientX - rect.left,
            y: e.clientY - rect.top,
        });
    };

    useEffect(() => {
        const equalHeight = () => {
            // 👉 H4 elements
            const headings = document.querySelectorAll(
                ".mietobjekte_wrapper .item_inner h3"
            );

            let maxH4 = 0;
            headings.forEach((el) => {
                el.style.height = "auto";
                maxH4 = Math.max(maxH4, el.offsetHeight);
            });
            headings.forEach((el) => {
                el.style.height = maxH4 + "px";
            });
        };

        // run on load
        setTimeout(equalHeight, 800);
        // run on resize
        window.addEventListener("resize", equalHeight);
        return () => {
            window.removeEventListener("resize", equalHeight);
        };
    }, []);


    const [isLoading, setIsLoading] = useState(false);
    const [pageData, setPageData] = useState(null);
    const [modules, setModules] = useState(null);
    const [headerModules, setHeaderModules] = useState(null);

    const [metaData, setMetaData] = useState(null);

    const getPageData = async () => {
        setIsLoading(true)
        try {
            const response = await fetch("https://backend.bgzurlinden.ch/api/freie-mietobjekte?populate[Bannerbereich][on][header.header-2-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-2-text-bild][populate][Videominiatur]=true&populate[Modul][on][modules.short-titel-titel-text-button][populate][Button][populate]=*&populate[Modul][on][modules.short-titel-titel-text-button][populate][PDF][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Button][populate]=*&populate[Modul][on][modules.formulare-reglemente-dokumente][populate][formulares][populate]=*&populate[Modul][on][modules.freie-objekte][populate][freie_objektes][populate][Bild]=true&populate[Modul][on][modules.freie-objekte][populate][freie_objektes][populate][Button]=true&populate[Metadaten]=*");



            // &populate[Modul][on][modules.freie-objekte][populate][freie_objektes][populate][Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true=*
            // &populate[Modul][on][modules.bestandesliegen-schaften][populate][siedlungens][populate][siedlungen_kategorien][populate]=*

            // &populate[Modul][on][modules.bestandesliegen-schaften][populate][siedlungens][populate][Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true


            // populate[Modul][on][modules.news][populate][Kurztitel_Titel_Text_Button][populate]=*
            // populate[Modul][on][modules.news][populate][aktuelles][populate][aktuelles_kategorie][populate]=*

            const data = await response.json();
            console.log(data?.data?.Modul);

            if (data.data) {
                setPageData(data.data);
                setModules(data?.data?.Modul);
                setHeaderModules(data?.data?.Bannerbereich);
                setMetaData(data.data?.Metadaten);
            }
        }
        catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }

    useEffect(() => {
        getPageData();
    }, [])

    const truncateBlocks = (blocks, maxLength = 120) => {
        if (!blocks) return "";

        let text = "";

        for (let block of blocks) {
            if (block.children) {
                for (let child of block.children) {
                    text += child.text;

                    if (text.length >= maxLength) {
                        return text.slice(0, maxLength) + "...";
                    }
                }
            }
        }

        return text;
    };

    const [visibleCount, setVisibleCount] = useState(9);

    return (
        <div className='page-content'>
            {metaData && <SEO seoData={metaData} />}

            {!isLoading && (
                headerModules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "header.header-2-text-bild" && (
                            <Header_2 module={module} isLoading={isLoading} title={module?.Titel} description={module?.Beschreibung} image={module?.Bild} sectionClass="banners-wohnen" activePage="wohnen" />
                        )}
                    </React.Fragment>
                ))
            )}

            {!isLoading ? (
                modules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "modules.short-titel-titel-text-button" &&
                            <section className={`pt-pb-10 sec-orange-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                <div className='container'>
                                    {/* <div className='subtitle'><img src='https://backend.bgzurlinden.ch/uploads/logo_icon_981b559742.svg' alt='#' /> zurlinden</div> */}
                                    <TitleTextButton data={module} shortTitle={module?.Kurztitel} title={module?.Titel} text={module?.Text} buttons={module?.Button} component={module?.Komponente} pdf={module?.PDF} />
                                </div>
                            </section>
                        }
                        {module.__component === "modules.carousel-bild-re-text" &&
                            <ImageTitleTextButton module={module} shortTitle={module?.Kurztitel} images={module?.Bild} title={module?.Titel} description={module?.Beschreibung} buttons={module?.Button} sectionColor="orange" imagePosition={module?.Bildposition} equalCol={module?.Gleiche_Spalten} />
                        }
                        {module.__component === "modules.freie-objekte" &&
                            // <section className='pt-pb-10 sec-orange-color sec-freie-mietobjekte'>
                            <section className={`pt-pb-10 sec-orange-color sec-freie-mietobjekte ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                <div className='container'>
                                    <div className='mietobjekte_wrapper'>
                                        <div className="row">
                                            {module?.freie_objektes?.slice(0, visibleCount)?.map((item, index) => (
                                                <div className="col-sm-6 col-lg-4 col-item mt-3 mt-lg-4">
                                                    <figure className="mb-0 item_inner">
                                                        <Link to={item?.Button?.button_link} target={item?.Button?.Target === "External" ? "_blank" : "_self"}
                                                            className={`fig-image ${hoveredId === item.id ? "hide_cursor" : ""
                                                                }`}
                                                            onMouseMove={mouseMove}
                                                            onMouseEnter={() => setHoveredId(item.id)}
                                                            onMouseLeave={() => setHoveredId(null)}
                                                        >
                                                            <img src={`https://backend.bgzurlinden.ch${item?.Bild?.url}`} alt="#" className="w-100" />
                                                            {hoveredId === item.id && (
                                                                <div
                                                                    className="image_cursor"
                                                                    style={{
                                                                        left: `${position.x}px`,
                                                                        top: `${position.y}px`,
                                                                    }}
                                                                >
                                                                    <img
                                                                        src="/images/cursor.png"
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            )}
                                                        </Link>
                                                        <figcaption>
                                                            <h3 className="text-darkgrey fw-550 fs-30"><Link to={item?.Button?.button_link} target={item?.Button?.Target === "External" ? "_blank" : "_self"}>{item?.Titel}</Link></h3>
                                                            {item?.Text && <p>{item?.Text}</p>}
                                                            {item?.Komponente && <Button component={item?.Komponente} pdf={[item?.PDF]} buttons={[item?.Button]} />}
                                                        </figcaption>
                                                    </figure>
                                                </div>
                                            ))}
                                        </div>
                                        {visibleCount < module?.freie_objektes?.length && (
                                            <div className='btn-container d-flex justify-content-center mt-4'>
                                                <button
                                                    className='button border-btn btn-theme-color'
                                                    onClick={() => setVisibleCount((prev) => prev + 9)}
                                                >
                                                    mehr
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </section>
                        }

                        {module.__component === "modules.formulare-reglemente-dokumente" &&
                            <section className={`pt-pb-10 sec-orange-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                <div className='container'>
                                    <DokumenteSlider formulare={module?.formulares} />
                                </div>
                            </section>}
                    </React.Fragment>
                ))
            ) : (
                <>
                    <section className={`banner_sec inner_banner wohnen-banner position-relative`}>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-md-5 col-lg-4 banner-content pt-pb-10'>
                                    <h1>{<Skeleton count={1} />}</h1>
                                    <p>{<Skeleton count={3} />}</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className={`pt-pb-10 sec-orange-color`}>
                        <div className='container'>
                            <div className='title-text-button-module'>
                                {/* {shortTitle && <div className='subtitle'>{shortTitle}</div>} */}
                                <div className='row'>
                                    <div className='col-lg-5 title-col'>
                                        {/* {title && <h2 className='text-black mb-lg-4 mb-2'>{title}</h2>} */}
                                        <h2>{<Skeleton count={1} />}</h2>
                                    </div>
                                    <div className='col-lg-7 content-col mt-3 mt-lg-0 fw_strong_500'>
                                        <p>{<Skeleton count={3} />}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )}


        </div>
    )
}